"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicRow = void 0;
exports.DefaultRow = DefaultRow;
exports.EmptyRow = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _makeClassNameComponent = require("../../utils/makeClassNameComponent");
var _Checkbox = require("../Checkbox");
var _CircularLoader = require("../CircularLoader");
var _Text = require("../Text");
var _Cell = require("./Cell");
var _TableModule = _interopRequireDefault(require("./Table.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// When using a custom Row prop, you need to create a component that looks like
//     MyRow = (props: TableRowProps<Entries, Extras>): React.Node => {...}
// otherwise flow will complain.
// Note that b/c extras is often optional, you will need to explicitly include
// `invariant(extras, 'extras exists');` in order to pull values out of
// extras (flow will remind you that it is of type `U | void`)

const BasicRow = exports.BasicRow = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.defaultRow, 'tr');
const EmptyRow = _ref => {
  let {
    isLoading,
    emptyText,
    headersLength = 0,
    customLoader
  } = _ref;
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: headersLength
  }, /*#__PURE__*/React.createElement("div", {
    className: _TableModule.default.emptyRow
  }, isLoading ? customLoader ? customLoader : /*#__PURE__*/React.createElement("div", {
    className: _TableModule.default.defaultLoader
  }, ' ', /*#__PURE__*/React.createElement(_CircularLoader.CircularLoader, {
    colorToken: "colorFillPrimary",
    size: "large"
  })) : emptyText || /*#__PURE__*/React.createElement(_Text.BodyLarge, {
    color: _Text.TEXT_COLORS.secondary,
    className: _TableModule.default.defaultEmptyText
  }, "Nothing to display here."))));
};

// This is a fallback row we use to render a table when
// initially stubbing out a design, the idea is you just avoid
// passing in a Row component and instead let this render out
// all the fields in the header in the short term
// Using the default row has the benefit that mismatches between
// header and entries _will_ error out even though there are the
// suppressions below
exports.EmptyRow = EmptyRow;
function DefaultRow(_ref2) {
  let {
    data,
    extras,
    headers,
    selected,
    onSelect,
    classNames,
    disabled
  } = _ref2;
  return /*#__PURE__*/React.createElement(BasicRow, {
    className: (0, _classify.default)(selected ? _TableModule.default.defaultSelectedBodyRow : _TableModule.default.defaultBodyRow, classNames?.tableRow)
  }, selected != null && /*#__PURE__*/React.createElement(_Cell.PaddedContentCell, {
    className: (0, _classify.default)(_TableModule.default.checkbox, classNames?.checkbox)
  }, /*#__PURE__*/React.createElement(_Checkbox.Checkbox, {
    checked: selected ? true : false,
    onChange: onSelect,
    disabled: disabled,
    ariaLabel: "Select row"
  })), headers.map((item, index) => {
    const {
      key,
      render: Renderer,
      className: cellClassName,
      sticky
    } = item;
    const value = data[key];
    return Renderer ? /*#__PURE__*/React.createElement(Renderer
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: index,
      data: data,
      extras: extras,
      selected: selected,
      disabled: disabled,
      className: (0, _classify.default)({
        [_TableModule.default.stickyCell]: sticky
      })
    }) : /*#__PURE__*/React.createElement(_Cell.SingleCell
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: index,
      title: String(value),
      className: (0, _classify.default)(cellClassName, {
        [_TableModule.default.stickyCell]: sticky
      })
    });
  }));
}